import { buildComponent } from '../dsfr';


const Hint = buildComponent('span', 'fr-hint-text');

export default Hint;
